import "./IconButtonNavLink.css";

import { useCallback, useEffect, useMemo } from "react";

import { CssClassNameBuilder } from "../../utils/CssClassNameBuilder1";
import { NavLink } from "react-router-dom";

export interface IIconButtonNavLinkProps{
    icon: React.ReactNode;
    navigateTo: string; 
    className?: string;
    /** Accessible name and tooltip (optional). */
    label?: string;
    /** Small counter on the icon (optional; hidden when undefined or 0). */
    badge?: number;
}

export function IconButtonNavLink(props: IIconButtonNavLinkProps) {

    const IconButtonCss = useCallback((funcProps: {
        isActive: boolean;
        isPending: boolean;
    }) => {
        return new CssClassNameBuilder()
        .add("icon-button-nav-link")
        .addConditional(funcProps.isActive || funcProps.isPending, "selected")
        .addConditional(props.className, props.className)
        .build();
    },[]);


    return (
        <NavLink to={props.navigateTo} className={IconButtonCss} title={props.label} aria-label={props.label}>
            <div className="icon">
                {props.icon}
                {props.badge ? <span className="icon-badge">{props.badge > 99 ? "99+" : props.badge}</span> : null}
            </div>
        </NavLink>
    );
}
